'use strict';

var _ = require('lodash');
var DemandTransparencyForecastProfileRegularTransformerFactory = function DemandTransparencyForecastProfileRegularTransformerFactory(DataTransformer, momentService) {
  function DemandTransparencyForecastProfileRegularTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'demand-transparency-forecast-profile-regular';
    this.targetType = 'demand-transparency-forecast-profile-chart';
    this.priority = 1;
  }
  DemandTransparencyForecastProfileRegularTransformer.prototype = Object.create(DataTransformer.prototype);
  DemandTransparencyForecastProfileRegularTransformer.constructor = DemandTransparencyForecastProfileRegularTransformer;
  DemandTransparencyForecastProfileRegularTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  DemandTransparencyForecastProfileRegularTransformer.prototype.isCacheable = function () {
    return false;
  };
  DemandTransparencyForecastProfileRegularTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  DemandTransparencyForecastProfileRegularTransformer.prototype.transform = function (data) {
    if (data.domain === undefined) {
      return undefined;
    }
    var results = [];
    _.forEach(data.domain.results, function (item) {
      var curveData = [];
      var demands = item.demands;
      var length = demands && demands.length;
      for (var i = 0; i < length; i++) {
        var demand = demands[i];
        curveData.push({
          dtd: +demand.readingTimeInterval.substring(0, demand.readingTimeInterval.indexOf('d')),
          demand: +demand.blendedRemainingDemandForecast
        });
      }
      if (curveData.length > 0) {
        results.push({
          lastProcessedDateTime: momentService.of(item.lastProcessedDateTime, momentService.FIELD.LAST_PROCESSED_DATE_TIME),
          hepKey: item.origin + item.destination + item.classGroup + item.significantPOS,
          classGroup: item.classGroup,
          dayOfWeekGroup: item.dayOfWeekGroup,
          season: item.season,
          profileLevel: item.profileLevel,
          curveData: curveData
        });
      }
    });
    return results;
  };
  return DemandTransparencyForecastProfileRegularTransformer;
};
DemandTransparencyForecastProfileRegularTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = DemandTransparencyForecastProfileRegularTransformerFactory;